import { jsx, css } from '@emotion/react';
import { connectLocation } from "../../location/LocationConnectors"
import Image from '../oc-image'
import RichText from "../oc-rich-text"
import Section from './oc-section';

const styles = css`
  .certifications {
    display: flex;
    flex-dirextion: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 0 -15px;

    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(100%/6);
      padding: 15px 15px;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    @media (max-width: 767px) {
      > div {
        width: 33%;
      }
    }
  }
`

const CertificationDisplay = ({proper_name, logo}) => (
  logo ? <Image src={logo.url} alt={proper_name} /> : <span>{proper_name}</span>
)

const Certifications = connectLocation(({ t, certifications, heading, anchor, className }) => (
  <Section anchor={anchor} css={styles} className={className}>
    <h2><RichText content={heading}/></h2>
    <div className="certifications">
      {certifications.map(({ uid, proper_name, images: { logo } = {} }) => (
        <div key={uid}>
          <CertificationDisplay logo={logo} proper_name={proper_name} />
        </div>
      ))}
    </div>
  </Section>
))

Certifications.WrappedComponent.displayName = 'Certifications'

export default Certifications
